import { createContext, useContext } from 'react';

export const ExternalFilterModeContext = createContext(false);

export const useIsExternalFilterMode = () => {
  return useContext(ExternalFilterModeContext);
};
